import React, { useEffect } from 'react'
import connect from './connect'

const TaskTickerManager = ({ startTicker }) => {
  useEffect(startTicker, [])
  return null
}

export default connect(TaskTickerManager)
